export default "__VITE_ASSET__6ff81c8e__"